import AdditionalProduct from 'components/detail/AdditionalProduct'
import Allergens from 'components/detail/Allergens'
import DetailTab from 'components/detail/DetailTab'
import GoWellTogether from 'components/detail/GoWellTogether'
import ImageSlider from 'components/detail/ImageSlider'
import { useRequest } from 'hooks/useRequest'
import NutritionalValues from 'components/detail/NutritionalValues'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import auth from 'utils/Auth'
import { useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import LoaderTwo from './LoaderTwo'
import BasketCardDrawer from 'containers/basketCardDrawer/BasketCardDrawer'
import ApprovalModal from 'components/approvalModal/ApprovalModal'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import { toast } from 'react-toastify'
import useTranslate from 'hooks/useTranslate'
import { dataLayerPush } from 'utils/Datalayer'

const Detail = () => {
	//const [detailTabStatus, setDetailTabStatus] = useState(1);
	const { id } = useParams()
	const [getItem, setGetItem] = useState(null)
	const [detailTabStatus, setDetailTabStatus] = useState(1)
	const [request, loading] = useRequest()
	const dispatch = useDispatch()
	const {t} = useTranslate()
	const navigate = useNavigate()
	const [isOpenDrawer, setIsOpenDrawer] = useState(false)
	const [singleDrawerProduct, setSingleDrawerProduct] = useState({ id: null, item: null })
	const [approvalModal, setApprovalModal] = useState({ open: false, order: null, type: null })
	const headerOptions = {
		RestaurantId: auth?.getUserChoises()?.restaurantId,
		DeliveryType: auth?.getUserChoises()?.deliveryType,
		NeighbourhoodId: auth?.getUserChoises()?.neighbourhoodId,
		RegionId: auth?.getUserChoises()?.regionId,
	}
	useEffect(() => {
		return () => {
			window.scrollTo(0, 0)
		}
	},[])
	useEffect(() => {
		request(`/Catalog/Products/${id}`, {
			method: 'GET',
			headers: headerOptions,
		}).then((res) => {
			if (res?.data) {
				setGetItem(res.data.result)
		
					dataLayerPush({ ecommerce: null });
					dataLayerPush({
						event:"view_item",
						item_list_name: "Listeleme Sayfası",
						ecommerce: {
							item_list_name: "Listeleme Sayfası",
							currency: "TRY",
							value: res?.data?.result?.price,
							items: [res.data.result]?.map((prev, i) => ({
								item_id: prev.id,
								item_name: prev.name,
								affilication: "Tavuk Dünyası",
								discount: prev.discountAmount,
								index: i,
								item_brand: "Tavuk Dünyası",
								item_category: prev.categories?.[0]?.value,
								item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
								item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
								item_list_name: "Listeleme Sayfası",
								price: prev.price,
							}))
						}
					})
				
			} else {
				toast.dismiss()
				navigate('/')
			}

		})
		window.scrollTo(0, 0)
	}, [id])


	// useEffect(() => {
	//   if (!isOpenDrawer) {
	//     setProductCount(1)
	//   }
	// }, [])

	const clearBasket = () => {
		if (approvalModal.type == 'DELETE') {
			request(`/ShoppingCart/RemoveItem?id=${approvalModal.order.id}`, {
				method: 'POST',
				//data: {id : id},
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res.data) {
					dispatch(getAllBasketFunc(res?.data?.result))
					toast.success(t('successfullToast',{type:t('delete'),name:''}))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		} else {
			request('/ShoppingCart/ClearCart', {
				method: 'POST',
				headers: {
					restaurantId: auth.getUserChoises()?.restaurantId,
					deliveryType: auth.getUserChoises()?.deliveryType,
					neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
					regionId: auth.getUserChoises()?.regionId,
				},
			}).then((res) => {
				if (res) {
					dispatch(getAllBasketFunc([]))
					setApprovalModal({ open: false, order: null, type: null })
				}
			})
		}
	}

  const structuredData = JSON.stringify(
    {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": getItem?.name,
      "image": getItem?.productImages?.[0],
      "description": getItem?.shortDescription,
      "brand": {
        "@type": "Brand",
        "name": "Tavuk Dünyası"
      },
      "offers": {
        "@type": "Offer",
        "url": [window.location.protocol, '//', window.location.host, window.location.pathname].join(''),
        "priceCurrency": "TRY",
        "price": `${getItem?.price}`,
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition"
      }
    }
  )
  
	return <div className='detail'>
			<LoaderTwo isDataLoading={loading} />
			<Helmet>
				<title>{getItem?.metaTitle || getItem?.name}</title>
				<meta name='description' content={getItem?.metaDescription || getItem?.shortDescription?.substr(0, 80)} />
				<script type='application/ld+json'>{structuredData}</script>
			</Helmet>
			<div className='detail-top'>
				<ImageSlider loading={loading} getItem={getItem} />
				<AdditionalProduct isOpenDrawer={isOpenDrawer} loadingProp={loading} getItem={getItem} />
			</div>
			<div className='detail-bottom'>
				<DetailTab detailTabStatus={detailTabStatus} setDetailTabStatus={setDetailTabStatus} />
				{detailTabStatus == 1 && (
					<GoWellTogether
						isOpenDrawer={isOpenDrawer}
						setIsOpenDrawer={setIsOpenDrawer}
						setSingleDrawerProduct={setSingleDrawerProduct}
						getItem={getItem}
					/>
				)}
				{detailTabStatus == 2 && <NutritionalValues getItem={getItem} />}
				{detailTabStatus == 3 && <Allergens getItem={getItem} />}
			</div>

			{/* <Drawer
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(!isOpenDrawer)}
        direction='right'
        className='homeAddBasketDrawer'
      >
        {productStage == 1 && <AddBasketDrawerStageOne isOpenDrawer={isOpenDrawer} setProductCount={setProductCount} productCount={productCount} productData={singleDrawerProduct} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
        {productStage == 2 && <AddBasketDrawerStageTwo setSingleDrawerProduct={setSingleDrawerProduct} isOpenDrawer={isOpenDrawer} getAllBasket={getAllBasket} setProductCount={setProductCount} productCount={productCount} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
      </Drawer> */}

			<ApprovalModal
				onClose={approvalModal.open}
				title={approvalModal.type == 'DELETE' ? t('youRemoveOrderFromList') : t('youRemoveProductFromCard')}
				desc={approvalModal.type == 'DELETE' ? t('sureYouWantRemoveFromListOrder') : t('sureYouWantClearBasket')}
				closeModal={() => setApprovalModal({ open: false, order: null, type: null })}
				onApproval={clearBasket}
			/>

			<BasketCardDrawer
				isOpenDrawer={isOpenDrawer}
				setIsOpenDrawer={setIsOpenDrawer}
				singleDrawerProduct={singleDrawerProduct}
				setApprovalModal={setApprovalModal}
				setSingleDrawerProduct={setSingleDrawerProduct}
			/>
		</div>
}

export default Detail
